import Client from './KomodoClient';
import { PAGE_ALL, pagerRows } from './Resource';

// Product pager shared by the channel-aware pickers (Shopify add-products). komodo has no
// api/product-sales-channel endpoint: category / product channels are saved with the product and
// category editors (MaterialSortDTO / MaterialDTO.ProductSalesChannels), as in Blazor.

// MaterialController query-pager: MaterialListSimpleDTO rows of a category (subtree) of a company.
const queryMaterials = (query) =>
	Client.post('/api/material/query-pager', {
		...PAGE_ALL,
		pageItems: 200,
		...(query || {}),
	}).then(pagerRows);

export default { queryMaterials };
